export type PictogramKind = 'item' | 'spell' | 'class' | 'npc';

export interface KitPictogram {
  id: string;
  kind: PictogramKind;
  category: string;
  name: string;
  src: string;
  itemType?: string;
}

export const KIT_ICON_PREFIX = '/icons/';
/** Cache-Bust für Kit-Icons nach Transparenz-Fix (Browser/CDN). */
export const KIT_ICON_VERSION = '20261029b';

export const KIT_PICTOGRAMS: KitPictogram[] = [
  { id: 'waffen-00', kind: 'item', category: 'Schwert', name: 'Goldklinge', src: '/icons/waffen-00.png', itemType: 'Waffe' },
  { id: 'waffen-01', kind: 'item', category: 'Schwert', name: 'Runenklinge', src: '/icons/waffen-01.png', itemType: 'Waffe' },
  { id: 'waffen-02', kind: 'item', category: 'Schwert', name: 'Rubinklinge', src: '/icons/waffen-02.png', itemType: 'Waffe' },
  { id: 'waffen-03', kind: 'item', category: 'Schwert', name: 'Saphirklinge', src: '/icons/waffen-03.png', itemType: 'Waffe' },
  { id: 'waffen-04', kind: 'item', category: 'Schwert', name: 'Giftklinge', src: '/icons/waffen-04.png', itemType: 'Waffe' },
  { id: 'waffen-10', kind: 'item', category: 'Bogen', name: 'Elfenbogen', src: '/icons/waffen-10.png', itemType: 'Waffe' },
  { id: 'waffen-11', kind: 'item', category: 'Bogen', name: 'Jägerbogen', src: '/icons/waffen-11.png', itemType: 'Waffe' },
  { id: 'waffen-12', kind: 'item', category: 'Bogen', name: 'Kristallbogen', src: '/icons/waffen-12.png', itemType: 'Waffe' },
  { id: 'waffen-13', kind: 'item', category: 'Bogen', name: 'Feuerbogen', src: '/icons/waffen-13.png', itemType: 'Waffe' },
  { id: 'waffen-14', kind: 'item', category: 'Bogen', name: 'Knochenbogen', src: '/icons/waffen-14.png', itemType: 'Waffe' },
  { id: 'waffen-20', kind: 'item', category: 'Axt', name: 'Streitaxt', src: '/icons/waffen-20.png', itemType: 'Waffe' },
  { id: 'waffen-21', kind: 'item', category: 'Axt', name: 'Doppelaxt', src: '/icons/waffen-21.png', itemType: 'Waffe' },
  { id: 'waffen-23', kind: 'item', category: 'Axt', name: 'Giftaxt', src: '/icons/waffen-23.png', itemType: 'Waffe' },
  { id: 'waffen-24', kind: 'item', category: 'Axt', name: 'Eisaxt', src: '/icons/waffen-24.png', itemType: 'Waffe' },
  { id: 'waffen-25', kind: 'item', category: 'Axt', name: 'Drachenaxt', src: '/icons/waffen-25.png', itemType: 'Waffe' },
  { id: 'haemmer-00', kind: 'item', category: 'Kriegshammer', name: 'Goldhammer', src: '/icons/haemmer-00.png', itemType: 'Waffe' },
  { id: 'haemmer-01', kind: 'item', category: 'Kriegshammer', name: 'Blitzhammer', src: '/icons/haemmer-01.png', itemType: 'Waffe' },
  { id: 'haemmer-02', kind: 'item', category: 'Kriegshammer', name: 'Juwelhammer', src: '/icons/haemmer-02.png', itemType: 'Waffe' },
  { id: 'haemmer-03', kind: 'item', category: 'Kriegshammer', name: 'Stachelhammer', src: '/icons/haemmer-03.png', itemType: 'Waffe' },
  { id: 'haemmer-04', kind: 'item', category: 'Kriegshammer', name: 'Sternhammer', src: '/icons/haemmer-04.png', itemType: 'Waffe' },
  { id: 'staebe-00', kind: 'item', category: 'Zauberstab', name: 'Goldstab', src: '/icons/staebe-00.png', itemType: 'Waffe' },
  { id: 'staebe-01', kind: 'item', category: 'Zauberstab', name: 'Orbstab', src: '/icons/staebe-01.png', itemType: 'Waffe' },
  { id: 'staebe-02', kind: 'item', category: 'Zauberstab', name: 'Naturstab', src: '/icons/staebe-02.png', itemType: 'Waffe' },
  { id: 'staebe-03', kind: 'item', category: 'Zauberstab', name: 'Eisstab', src: '/icons/staebe-03.png', itemType: 'Waffe' },
  { id: 'staebe-04', kind: 'item', category: 'Zauberstab', name: 'Feuerstab', src: '/icons/staebe-04.png', itemType: 'Waffe' },
  { id: 'ruestung-00', kind: 'item', category: 'Schild', name: 'Saphirschild', src: '/icons/ruestung-00.png', itemType: 'Ruestung' },
  { id: 'ruestung-01', kind: 'item', category: 'Schild', name: 'Schädelschild', src: '/icons/ruestung-01.png', itemType: 'Ruestung' },
  { id: 'ruestung-02', kind: 'item', category: 'Schild', name: 'Eisschild', src: '/icons/ruestung-02.png', itemType: 'Ruestung' },
  { id: 'ruestung-03', kind: 'item', category: 'Schild', name: 'Rankenschild', src: '/icons/ruestung-03.png', itemType: 'Ruestung' },
  { id: 'ruestung-04', kind: 'item', category: 'Schild', name: 'Löwenschild', src: '/icons/ruestung-04.png', itemType: 'Ruestung' },
  { id: 'ruestung-10', kind: 'item', category: 'Helm', name: 'Ritterhelm', src: '/icons/ruestung-10.png', itemType: 'Ruestung' },
  { id: 'ruestung-11', kind: 'item', category: 'Helm', name: 'Hörnerhelm', src: '/icons/ruestung-11.png', itemType: 'Ruestung' },
  { id: 'ruestung-12', kind: 'item', category: 'Helm', name: 'Visierhelm', src: '/icons/ruestung-12.png', itemType: 'Ruestung' },
  { id: 'ruestung-13', kind: 'item', category: 'Helm', name: 'Kapuzenhelm', src: '/icons/ruestung-13.png', itemType: 'Ruestung' },
  { id: 'ruestung-14', kind: 'item', category: 'Helm', name: 'Federhelm', src: '/icons/ruestung-14.png', itemType: 'Ruestung' },
  { id: 'ruestung-20', kind: 'item', category: 'Rüstung', name: 'Goldharnisch', src: '/icons/ruestung-20.png', itemType: 'Ruestung' },
  { id: 'ruestung-21', kind: 'item', category: 'Rüstung', name: 'Lederpanzer', src: '/icons/ruestung-21.png', itemType: 'Ruestung' },
  { id: 'ruestung-22', kind: 'item', category: 'Rüstung', name: 'Magiermantel', src: '/icons/ruestung-22.png', itemType: 'Ruestung' },
  { id: 'ruestung-23', kind: 'item', category: 'Rüstung', name: 'Schuppenpanzer', src: '/icons/ruestung-23.png', itemType: 'Ruestung' },
  { id: 'ruestung-24', kind: 'item', category: 'Rüstung', name: 'Tempelharnisch', src: '/icons/ruestung-24.png', itemType: 'Ruestung' },
  { id: 'schuhe-00', kind: 'item', category: 'Schuhe', name: 'Kristallstiefel', src: '/icons/schuhe-00.png', itemType: 'Schuhe' },
  { id: 'schuhe-01', kind: 'item', category: 'Schuhe', name: 'Lederstiefel', src: '/icons/schuhe-01.png', itemType: 'Schuhe' },
  { id: 'schuhe-02', kind: 'item', category: 'Schuhe', name: 'Drachenstiefel', src: '/icons/schuhe-02.png', itemType: 'Schuhe' },
  { id: 'schuhe-03', kind: 'item', category: 'Schuhe', name: 'Magierschuhe', src: '/icons/schuhe-03.png', itemType: 'Schuhe' },
  { id: 'schuhe-04', kind: 'item', category: 'Schuhe', name: 'Schwingenstiefel', src: '/icons/schuhe-04.png', itemType: 'Schuhe' },
  { id: 'handschuhe-00', kind: 'item', category: 'Handschuhe', name: 'Lederhandschuhe', src: '/icons/handschuhe-00.png', itemType: 'Ruestung' },
  { id: 'handschuhe-01', kind: 'item', category: 'Handschuhe', name: 'Eisenstulpen', src: '/icons/handschuhe-01.png', itemType: 'Ruestung' },
  { id: 'handschuhe-02', kind: 'item', category: 'Handschuhe', name: 'Drachenhandschuhe', src: '/icons/handschuhe-02.png', itemType: 'Ruestung' },
  { id: 'handschuhe-03', kind: 'item', category: 'Handschuhe', name: 'Magierhandschuhe', src: '/icons/handschuhe-03.png', itemType: 'Ruestung' },
  { id: 'handschuhe-04', kind: 'item', category: 'Handschuhe', name: 'Schwingenhandschuhe', src: '/icons/handschuhe-04.png', itemType: 'Ruestung' },
  { id: 'trank-00', kind: 'item', category: 'Kleiner Trank', name: 'Kleiner Heiltrank', src: '/icons/trank-00.png', itemType: 'Trank' },
  { id: 'trank-klein-01', kind: 'item', category: 'Kleiner Trank', name: 'Kleiner Manatrank', src: '/icons/trank-klein-01.png', itemType: 'Trank' },
  { id: 'trank-klein-02', kind: 'item', category: 'Kleiner Trank', name: 'Kleiner Grüntrank', src: '/icons/trank-klein-02.png', itemType: 'Trank' },
  { id: 'trank-klein-03', kind: 'item', category: 'Kleiner Trank', name: 'Kleiner Goldtrank', src: '/icons/trank-klein-03.png', itemType: 'Trank' },
  { id: 'trank-klein-04', kind: 'item', category: 'Kleiner Trank', name: 'Kleiner Flammentrank', src: '/icons/trank-klein-04.png', itemType: 'Trank' },
  { id: 'ausruestung-00', kind: 'item', category: 'Mittlerer Trank', name: 'Heiltrank', src: '/icons/ausruestung-00.png', itemType: 'Trank' },
  { id: 'ausruestung-01', kind: 'item', category: 'Mittlerer Trank', name: 'Manatrank', src: '/icons/ausruestung-01.png', itemType: 'Trank' },
  { id: 'ausruestung-02', kind: 'item', category: 'Mittlerer Trank', name: 'Grüntrank', src: '/icons/ausruestung-02.png', itemType: 'Trank' },
  { id: 'ausruestung-03', kind: 'item', category: 'Mittlerer Trank', name: 'Goldtrank', src: '/icons/ausruestung-03.png', itemType: 'Trank' },
  { id: 'ausruestung-04', kind: 'item', category: 'Mittlerer Trank', name: 'Flammentrank', src: '/icons/ausruestung-04.png', itemType: 'Trank' },
  { id: 'trank-02', kind: 'item', category: 'Großer Trank', name: 'Großer Heiltrank', src: '/icons/trank-02.png', itemType: 'Trank' },
  { id: 'trank-gross-01', kind: 'item', category: 'Großer Trank', name: 'Großer Manatrank', src: '/icons/trank-gross-01.png', itemType: 'Trank' },
  { id: 'trank-gross-02', kind: 'item', category: 'Großer Trank', name: 'Großer Grüntrank', src: '/icons/trank-gross-02.png', itemType: 'Trank' },
  { id: 'trank-gross-03', kind: 'item', category: 'Großer Trank', name: 'Großer Goldtrank', src: '/icons/trank-gross-03.png', itemType: 'Trank' },
  { id: 'trank-gross-04', kind: 'item', category: 'Großer Trank', name: 'Großer Flammentrank', src: '/icons/trank-gross-04.png', itemType: 'Trank' },
  { id: 'trank-03', kind: 'item', category: 'Epischer Trank', name: 'Epischer Heiltrank', src: '/icons/trank-03.png', itemType: 'Trank' },
  { id: 'trank-episch-01', kind: 'item', category: 'Epischer Trank', name: 'Epischer Manatrank', src: '/icons/trank-episch-01.png', itemType: 'Trank' },
  { id: 'trank-episch-02', kind: 'item', category: 'Epischer Trank', name: 'Epischer Grüntrank', src: '/icons/trank-episch-02.png', itemType: 'Trank' },
  { id: 'trank-episch-03', kind: 'item', category: 'Epischer Trank', name: 'Epischer Goldtrank', src: '/icons/trank-episch-03.png', itemType: 'Trank' },
  { id: 'trank-episch-04', kind: 'item', category: 'Epischer Trank', name: 'Epischer Flammentrank', src: '/icons/trank-episch-04.png', itemType: 'Trank' },
  { id: 'ausruestung-10', kind: 'item', category: 'Schmuck', name: 'Rubinring', src: '/icons/ausruestung-10.png', itemType: 'Schmuck' },
  { id: 'ausruestung-11', kind: 'item', category: 'Schmuck', name: 'Amulett', src: '/icons/ausruestung-11.png', itemType: 'Schmuck' },
  { id: 'ausruestung-12', kind: 'item', category: 'Schmuck', name: 'Edelsteinreif', src: '/icons/ausruestung-12.png', itemType: 'Schmuck' },
  { id: 'ausruestung-13', kind: 'item', category: 'Schmuck', name: 'Perlenkette', src: '/icons/ausruestung-13.png', itemType: 'Schmuck' },
  { id: 'ausruestung-14', kind: 'item', category: 'Schmuck', name: 'Smaragdanhänger', src: '/icons/ausruestung-14.png', itemType: 'Schmuck' },
  { id: 'ausruestung-20', kind: 'item', category: 'Schlüssel', name: 'Goldschlüssel', src: '/icons/ausruestung-20.png', itemType: 'Schluessel' },
  { id: 'ausruestung-21', kind: 'item', category: 'Schlüssel', name: 'Eisenschlüssel', src: '/icons/ausruestung-21.png', itemType: 'Schluessel' },
  { id: 'ausruestung-22', kind: 'item', category: 'Schlüssel', name: 'Kristallschlüssel', src: '/icons/ausruestung-22.png', itemType: 'Schluessel' },
  { id: 'ausruestung-23', kind: 'item', category: 'Schlüssel', name: 'Schädelschlüssel', src: '/icons/ausruestung-23.png', itemType: 'Schluessel' },
  { id: 'ausruestung-24', kind: 'item', category: 'Schlüssel', name: 'Rubinschlüssel', src: '/icons/ausruestung-24.png', itemType: 'Schluessel' },
  { id: 'schrift-00', kind: 'item', category: 'Schriftrolle', name: 'Goldsiegel', src: '/icons/schrift-00.png', itemType: 'Schriftrolle' },
  { id: 'schrift-01', kind: 'item', category: 'Schriftrolle', name: 'Runenrolle', src: '/icons/schrift-01.png', itemType: 'Schriftrolle' },
  { id: 'schrift-02', kind: 'item', category: 'Schriftrolle', name: 'Eisrolle', src: '/icons/schrift-02.png', itemType: 'Schriftrolle' },
  { id: 'schrift-03', kind: 'item', category: 'Schriftrolle', name: 'Feuerrolle', src: '/icons/schrift-03.png', itemType: 'Schriftrolle' },
  { id: 'schrift-04', kind: 'item', category: 'Schriftrolle', name: 'Naturrolle', src: '/icons/schrift-04.png', itemType: 'Schriftrolle' },
  { id: 'schrift-10', kind: 'item', category: 'Werkzeug', name: 'Spitzhacke', src: '/icons/schrift-10.png', itemType: 'Werkzeug' },
  { id: 'schrift-11', kind: 'item', category: 'Werkzeug', name: 'Laterne', src: '/icons/schrift-11.png', itemType: 'Werkzeug' },
  { id: 'schrift-12', kind: 'item', category: 'Werkzeug', name: 'Schmiedehammer', src: '/icons/schrift-12.png', itemType: 'Werkzeug' },
  { id: 'schrift-13', kind: 'item', category: 'Werkzeug', name: 'Fackel', src: '/icons/schrift-13.png', itemType: 'Werkzeug' },
  { id: 'schrift-14', kind: 'item', category: 'Werkzeug', name: 'Enterhaken', src: '/icons/schrift-14.png', itemType: 'Werkzeug' },
  { id: 'schrift-20', kind: 'item', category: 'Sonstiges', name: 'Goldmünzen', src: '/icons/schrift-20.png', itemType: 'Sonstiges' },
  { id: 'sonstiges-naturessenz', kind: 'item', category: 'Sonstiges', name: 'Naturessenz', src: '/icons/sonstiges-naturessenz.png', itemType: 'Sonstiges' },
  { id: 'schrift-21', kind: 'item', category: 'Sonstiges', name: 'Reisetasche', src: '/icons/schrift-21.png', itemType: 'Sonstiges' },
  { id: 'schrift-22', kind: 'item', category: 'Sonstiges', name: 'Kompass', src: '/icons/schrift-22.png', itemType: 'Sonstiges' },
  { id: 'schrift-23', kind: 'item', category: 'Sonstiges', name: 'Schatztruhe', src: '/icons/schrift-23.png', itemType: 'Sonstiges' },
  { id: 'schrift-24', kind: 'item', category: 'Sonstiges', name: 'Trinkhorn', src: '/icons/schrift-24.png', itemType: 'Sonstiges' },
  { id: 'sonstiges-wuerfel-angriff', kind: 'item', category: 'Würfel', name: 'Angriffswürfel', src: '/icons/sonstiges-wuerfel-angriff.png', itemType: 'Sonstiges' },
  { id: 'sonstiges-wuerfel-ruestung', kind: 'item', category: 'Würfel', name: 'Rüstungswürfel', src: '/icons/sonstiges-wuerfel-ruestung.png', itemType: 'Sonstiges' },
  { id: 'sonstiges-pferd', kind: 'item', category: 'Sonstiges', name: 'Pferd', src: '/icons/sonstiges-pferd.png', itemType: 'Sonstiges' },
  { id: 'waffen-speer', kind: 'item', category: 'Speer', name: 'Speer', src: '/icons/waffen-speer.png', itemType: 'Waffe' },
  { id: 'werkzeug-lagerfeuer', kind: 'item', category: 'Werkzeug', name: 'Lagerfeuer', src: '/icons/werkzeug-lagerfeuer.png', itemType: 'Werkzeug' },
  { id: 'werkzeug-reparatur', kind: 'item', category: 'Werkzeug', name: 'Reparatursatz', src: '/icons/werkzeug-reparatur.png', itemType: 'Werkzeug' },
  { id: 'element-00', kind: 'spell', category: 'Feuer', name: 'Feuerball', src: '/icons/element-00.png' },
  { id: 'element-01', kind: 'spell', category: 'Feuer', name: 'Phönix', src: '/icons/element-01.png' },
  { id: 'element-02', kind: 'spell', category: 'Feuer', name: 'Meteor', src: '/icons/element-02.png' },
  { id: 'element-03', kind: 'spell', category: 'Feuer', name: 'Flammenschwert', src: '/icons/element-03.png' },
  { id: 'element-04', kind: 'spell', category: 'Feuer', name: 'Feuerwirbel', src: '/icons/element-04.png' },
  { id: 'element-10', kind: 'spell', category: 'Eis', name: 'Eiskristall', src: '/icons/element-10.png' },
  { id: 'element-11', kind: 'spell', category: 'Eis', name: 'Schneeflocke', src: '/icons/element-11.png' },
  { id: 'element-12', kind: 'spell', category: 'Eis', name: 'Frostwirbel', src: '/icons/element-12.png' },
  { id: 'element-13', kind: 'spell', category: 'Eis', name: 'Eisklinge', src: '/icons/element-13.png' },
  { id: 'element-14', kind: 'spell', category: 'Eis', name: 'Frostwolf', src: '/icons/element-14.png' },
  { id: 'element-20', kind: 'spell', category: 'Blitz', name: 'Donnerkeil', src: '/icons/element-20.png' },
  { id: 'element-21', kind: 'spell', category: 'Blitz', name: 'Gewitter', src: '/icons/element-21.png' },
  { id: 'element-22', kind: 'spell', category: 'Blitz', name: 'Blitzkugel', src: '/icons/element-22.png' },
  { id: 'element-23', kind: 'spell', category: 'Blitz', name: 'Blitzspeer', src: '/icons/element-23.png' },
  { id: 'element-24', kind: 'spell', category: 'Blitz', name: 'Blitzring', src: '/icons/element-24.png' },
  { id: 'schule-00', kind: 'spell', category: 'Natur', name: 'Ranke', src: '/icons/schule-00.png' },
  { id: 'schule-01', kind: 'spell', category: 'Natur', name: 'Blüte', src: '/icons/schule-01.png' },
  { id: 'schule-02', kind: 'spell', category: 'Natur', name: 'Steingeist', src: '/icons/schule-02.png' },
  { id: 'schule-03', kind: 'spell', category: 'Natur', name: 'Wolfsgeist', src: '/icons/schule-03.png' },
  { id: 'schule-04', kind: 'spell', category: 'Natur', name: 'Pilzwald', src: '/icons/schule-04.png' },
  { id: 'schule-10', kind: 'spell', category: 'Dunkel', name: 'Schädel', src: '/icons/schule-10.png' },
  { id: 'schule-11', kind: 'spell', category: 'Dunkel', name: 'Mondschatten', src: '/icons/schule-11.png' },
  { id: 'schule-12', kind: 'spell', category: 'Dunkel', name: 'Auge', src: '/icons/schule-12.png' },
  { id: 'schule-13', kind: 'spell', category: 'Dunkel', name: 'Hornschädel', src: '/icons/schule-13.png' },
  { id: 'schule-14', kind: 'spell', category: 'Dunkel', name: 'Fledermausdämon', src: '/icons/schule-14.png' },
  { id: 'schule-20', kind: 'spell', category: 'Licht', name: 'Sonne', src: '/icons/schule-20.png' },
  { id: 'schule-21', kind: 'spell', category: 'Licht', name: 'Schwinge', src: '/icons/schule-21.png' },
  { id: 'schule-22', kind: 'spell', category: 'Licht', name: 'Heiliges Kreuz', src: '/icons/schule-22.png' },
  { id: 'schule-23', kind: 'spell', category: 'Licht', name: 'Sonnenschild', src: '/icons/schule-23.png' },
  { id: 'schule-24', kind: 'spell', category: 'Licht', name: 'Weihkelch', src: '/icons/schule-24.png' },
  { id: 'arkan-00', kind: 'spell', category: 'Arkan', name: 'Pentagramm', src: '/icons/arkan-00.png' },
  { id: 'arkan-01', kind: 'spell', category: 'Arkan', name: 'Portal', src: '/icons/arkan-01.png' },
  { id: 'arkan-02', kind: 'spell', category: 'Arkan', name: 'Kristallstab', src: '/icons/arkan-02.png' },
  { id: 'arkan-03', kind: 'spell', category: 'Arkan', name: 'Zauberbuch', src: '/icons/arkan-03.png' },
  { id: 'arkan-04', kind: 'spell', category: 'Arkan', name: 'Portalwirbel', src: '/icons/arkan-04.png' },
  { id: 'arkan-10', kind: 'spell', category: 'Heilung', name: 'Segenkreuz', src: '/icons/arkan-10.png' },
  { id: 'arkan-11', kind: 'spell', category: 'Heilung', name: 'Blattphiole', src: '/icons/arkan-11.png' },
  { id: 'arkan-12', kind: 'spell', category: 'Heilung', name: 'Heilende Hände', src: '/icons/arkan-12.png' },
  { id: 'arkan-13', kind: 'spell', category: 'Heilung', name: 'Verbandherz', src: '/icons/arkan-13.png' },
  { id: 'arkan-14', kind: 'spell', category: 'Heilung', name: 'Heilbrunnen', src: '/icons/arkan-14.png' },
  { id: 'arkan-wand', kind: 'spell', category: 'Arkan', name: 'Magiewand', src: '/icons/arkan-wand.png' },
  { id: 'arkan-schmiede', kind: 'spell', category: 'Arkan', name: 'Schmiedezauber', src: '/icons/arkan-schmiede.png' },
  { id: 'arkan-wuerfel', kind: 'spell', category: 'Arkan', name: 'Würfel der Magie', src: '/icons/arkan-wuerfel.png' },
  { id: 'arkan-staerke', kind: 'spell', category: 'Arkan', name: 'Stärkezauber', src: '/icons/arkan-staerke.png' },
  { id: 'arkan-flinke-fuesse', kind: 'spell', category: 'Arkan', name: 'Flinke Füße', src: '/icons/arkan-flinke-fuesse.png' },
  { id: 'arkan-wiederbelebung', kind: 'spell', category: 'Heilung', name: 'Wiederbelebung', src: '/icons/arkan-wiederbelebung.png' },
  { id: 'klasse-krieger-00', kind: 'class', category: 'Krieger', name: 'Kreuzklingen', src: '/icons/klasse-krieger-00.png' },
  { id: 'klasse-krieger-01', kind: 'class', category: 'Krieger', name: 'Kriegshelm', src: '/icons/klasse-krieger-01.png' },
  { id: 'klasse-krieger-02', kind: 'class', category: 'Krieger', name: 'Streitaxt', src: '/icons/klasse-krieger-02.png' },
  { id: 'klasse-krieger-03', kind: 'class', category: 'Krieger', name: 'Stachelschild', src: '/icons/klasse-krieger-03.png' },
  { id: 'klasse-krieger-04', kind: 'class', category: 'Krieger', name: 'Turmklingen', src: '/icons/klasse-krieger-04.png' },
  { id: 'klasse-magier-00', kind: 'class', category: 'Magier', name: 'Spitzhut', src: '/icons/klasse-magier-00.png' },
  { id: 'klasse-magier-01', kind: 'class', category: 'Magier', name: 'Orbstab', src: '/icons/klasse-magier-01.png' },
  { id: 'klasse-magier-02', kind: 'class', category: 'Magier', name: 'Zauberbuch', src: '/icons/klasse-magier-02.png' },
  { id: 'klasse-magier-03', kind: 'class', category: 'Magier', name: 'Kristallstab', src: '/icons/klasse-magier-03.png' },
  { id: 'klasse-magier-04', kind: 'class', category: 'Magier', name: 'Mondsichel', src: '/icons/klasse-magier-04.png' },
  { id: 'klasse-wald-00', kind: 'class', category: 'Waldläufer', name: 'Elfenbogen', src: '/icons/klasse-wald-00.png' },
  { id: 'klasse-wald-01', kind: 'class', category: 'Waldläufer', name: 'Wolfsgeist', src: '/icons/klasse-wald-01.png' },
  { id: 'klasse-wald-02', kind: 'class', category: 'Waldläufer', name: 'Köcher', src: '/icons/klasse-wald-02.png' },
  { id: 'klasse-wald-03', kind: 'class', category: 'Waldläufer', name: 'Geweih', src: '/icons/klasse-wald-03.png' },
  { id: 'klasse-wald-04', kind: 'class', category: 'Waldläufer', name: 'Jagdfalke', src: '/icons/klasse-wald-04.png' },
  { id: 'klasse-priester-00', kind: 'class', category: 'Priester', name: 'Herzkreuz', src: '/icons/klasse-priester-00.png' },
  { id: 'klasse-priester-01', kind: 'class', category: 'Priester', name: 'Weihkelch', src: '/icons/klasse-priester-01.png' },
  { id: 'klasse-priester-02', kind: 'class', category: 'Priester', name: 'Heilige Sonne', src: '/icons/klasse-priester-02.png' },
  { id: 'klasse-priester-03', kind: 'class', category: 'Priester', name: 'Friedenstaube', src: '/icons/klasse-priester-03.png' },
  { id: 'klasse-priester-04', kind: 'class', category: 'Priester', name: 'Segenshände', src: '/icons/klasse-priester-04.png' },
  { id: 'klasse-dieb-00', kind: 'class', category: 'Dieb', name: 'Kreuzdolche', src: '/icons/klasse-dieb-00.png' },
  { id: 'klasse-dieb-01', kind: 'class', category: 'Dieb', name: 'Schattenkapuze', src: '/icons/klasse-dieb-01.png' },
  { id: 'klasse-dieb-02', kind: 'class', category: 'Dieb', name: 'Goldbeutel', src: '/icons/klasse-dieb-02.png' },
  { id: 'klasse-dieb-03', kind: 'class', category: 'Dieb', name: 'Schattenkatze', src: '/icons/klasse-dieb-03.png' },
  { id: 'klasse-dieb-04', kind: 'class', category: 'Dieb', name: 'Krummdolch', src: '/icons/klasse-dieb-04.png' },
  { id: 'klasse-paladin-00', kind: 'class', category: 'Paladin', name: 'Kreuzschild', src: '/icons/klasse-paladin-00.png' },
  { id: 'klasse-paladin-01', kind: 'class', category: 'Paladin', name: 'Schwingenhammer', src: '/icons/klasse-paladin-01.png' },
  { id: 'klasse-paladin-02', kind: 'class', category: 'Paladin', name: 'Sonnenklinge', src: '/icons/klasse-paladin-02.png' },
  { id: 'klasse-paladin-03', kind: 'class', category: 'Paladin', name: 'Federhelm', src: '/icons/klasse-paladin-03.png' },
  { id: 'klasse-paladin-04', kind: 'class', category: 'Paladin', name: 'Engelschwinge', src: '/icons/klasse-paladin-04.png' },
  { id: 'klasse-heiler', kind: 'class', category: 'Heiler', name: 'Heilkreuz', src: '/icons/klasse-heiler.png' },
  { id: 'klasse-druide', kind: 'class', category: 'Druide', name: 'Geweihblatt', src: '/icons/klasse-druide.png' },
  { id: 'klasse-fee', kind: 'class', category: 'Fee', name: 'Feenschwingen', src: '/icons/klasse-fee.png' },
  { id: 'klasse-nekromant', kind: 'class', category: 'Nekromant', name: 'Totenkrone', src: '/icons/klasse-nekromant.png' },
  { id: 'klasse-assassine', kind: 'class', category: 'Assassine', name: 'Schattendolche', src: '/icons/klasse-assassine.png' },
  { id: 'klasse-moench', kind: 'class', category: 'Mönch', name: 'Gebetsring', src: '/icons/klasse-moench.png' },
  { id: 'klasse-akrobat', kind: 'class', category: 'Akrobat', name: 'Sprungband', src: '/icons/klasse-akrobat.png' },
  { id: 'klasse-elementar', kind: 'class', category: 'Elementarmagier', name: 'Elementardreieck', src: '/icons/klasse-elementar.png' },
  { id: 'klasse-oger', kind: 'class', category: 'Oger', name: 'Ogergesicht', src: '/icons/klasse-oger.png' },
  { id: 'klasse-pilz', kind: 'class', category: 'Pilzmensch', name: 'Leuchtpilz', src: '/icons/klasse-pilz.png' },
  { id: 'klasse-orc-kaempferin', kind: 'class', category: 'Orc-Kämpferin', name: 'Orc-Kämpferin', src: '/icons/klasse-orc-kaempferin.png' },
  { id: 'klasse-mystischer-schuetze', kind: 'class', category: 'Mystischer Schütze', name: 'Mystischer Schütze', src: '/icons/klasse-mystischer-schuetze.png' },
  { id: 'klasse-walddrache', kind: 'class', category: 'Walddrache', name: 'Walddrache', src: '/icons/klasse-walddrache.png' },
  { id: 'klasse-gefaehrte', kind: 'class', category: 'Gefährte', name: 'Gefährte', src: '/icons/klasse-gefaehrte.png' },
  { id: 'klasse-waldschrat', kind: 'class', category: 'Waldschrat', name: 'Waldschrat', src: '/icons/klasse-waldschrat.png' },
  { id: 'gegner-ork-00', kind: 'npc', category: 'Ork', name: 'Orkgesicht', src: '/icons/gegner-ork-00.png' },
  { id: 'gegner-ork-01', kind: 'npc', category: 'Ork', name: 'Streitäxte', src: '/icons/gegner-ork-01.png' },
  { id: 'gegner-ork-02', kind: 'npc', category: 'Ork', name: 'Orkhelm', src: '/icons/gegner-ork-02.png' },
  { id: 'gegner-ork-03', kind: 'npc', category: 'Ork', name: 'Hauer', src: '/icons/gegner-ork-03.png' },
  { id: 'gegner-ork-04', kind: 'npc', category: 'Ork', name: 'Kriegshelm', src: '/icons/gegner-ork-04.png' },
  { id: 'gegner-goblin-00', kind: 'npc', category: 'Goblin', name: 'Grinsen', src: '/icons/gegner-goblin-00.png' },
  { id: 'gegner-goblin-01', kind: 'npc', category: 'Goblin', name: 'Giftdolch', src: '/icons/gegner-goblin-01.png' },
  { id: 'gegner-goblin-02', kind: 'npc', category: 'Goblin', name: 'Bombe', src: '/icons/gegner-goblin-02.png' },
  { id: 'gegner-goblin-03', kind: 'npc', category: 'Goblin', name: 'Kapuze', src: '/icons/gegner-goblin-03.png' },
  { id: 'gegner-goblin-04', kind: 'npc', category: 'Goblin', name: 'Beutel', src: '/icons/gegner-goblin-04.png' },
  { id: 'gegner-drache-00', kind: 'npc', category: 'Drache', name: 'Drachenkopf', src: '/icons/gegner-drache-00.png' },
  { id: 'gegner-drache-01', kind: 'npc', category: 'Drache', name: 'Feuerflug', src: '/icons/gegner-drache-01.png' },
  { id: 'gegner-drache-02', kind: 'npc', category: 'Drache', name: 'Goldwyrm', src: '/icons/gegner-drache-02.png' },
  { id: 'gegner-drache-03', kind: 'npc', category: 'Drache', name: 'Klaue', src: '/icons/gegner-drache-03.png' },
  { id: 'gegner-drache-04', kind: 'npc', category: 'Drache', name: 'Flammenauge', src: '/icons/gegner-drache-04.png' },
  { id: 'gegner-untoter-00', kind: 'npc', category: 'Untoter', name: 'Totenkopf', src: '/icons/gegner-untoter-00.png' },
  { id: 'gegner-untoter-01', kind: 'npc', category: 'Untoter', name: 'Lichkrone', src: '/icons/gegner-untoter-01.png' },
  { id: 'gegner-untoter-02', kind: 'npc', category: 'Untoter', name: 'Gruft', src: '/icons/gegner-untoter-02.png' },
  { id: 'gegner-untoter-03', kind: 'npc', category: 'Untoter', name: 'Grabeshand', src: '/icons/gegner-untoter-03.png' },
  { id: 'gegner-untoter-04', kind: 'npc', category: 'Untoter', name: 'Geist', src: '/icons/gegner-untoter-04.png' },
  { id: 'gegner-bandit-00', kind: 'npc', category: 'Bandit', name: 'Maske', src: '/icons/gegner-bandit-00.png' },
  { id: 'gegner-bandit-01', kind: 'npc', category: 'Bandit', name: 'Beute', src: '/icons/gegner-bandit-01.png' },
  { id: 'gegner-bandit-02', kind: 'npc', category: 'Bandit', name: 'Dolchkapuze', src: '/icons/gegner-bandit-02.png' },
  { id: 'gegner-bandit-03', kind: 'npc', category: 'Bandit', name: 'Armbrust', src: '/icons/gegner-bandit-03.png' },
  { id: 'gegner-bandit-04', kind: 'npc', category: 'Bandit', name: 'Meuchelmesser', src: '/icons/gegner-bandit-04.png' },
  { id: 'gegner-bestie-00', kind: 'npc', category: 'Bestie', name: 'Wolf', src: '/icons/gegner-bestie-00.png' },
  { id: 'gegner-bestie-01', kind: 'npc', category: 'Bestie', name: 'Bär', src: '/icons/gegner-bestie-01.png' },
  { id: 'gegner-bestie-02', kind: 'npc', category: 'Bestie', name: 'Spinne', src: '/icons/gegner-bestie-02.png' },
  { id: 'gegner-bestie-03', kind: 'npc', category: 'Bestie', name: 'Ratte', src: '/icons/gegner-bestie-03.png' },
  { id: 'gegner-bestie-04', kind: 'npc', category: 'Bestie', name: 'Schlange', src: '/icons/gegner-bestie-04.png' },
  { id: 'gegner-daemon-00', kind: 'npc', category: 'Dämon', name: 'Dämon', src: '/icons/gegner-daemon-00.png' },
  { id: 'gegner-daemon-01', kind: 'npc', category: 'Dämon', name: 'Imp', src: '/icons/gegner-daemon-01.png' },
  { id: 'gegner-daemon-02', kind: 'npc', category: 'Dämon', name: 'Pentagramm', src: '/icons/gegner-daemon-02.png' },
  { id: 'gegner-daemon-03', kind: 'npc', category: 'Dämon', name: 'Infernoauge', src: '/icons/gegner-daemon-03.png' },
  { id: 'gegner-daemon-04', kind: 'npc', category: 'Dämon', name: 'Hörner', src: '/icons/gegner-daemon-04.png' },
  { id: 'gegner-konstrukt-00', kind: 'npc', category: 'Konstrukt', name: 'Golem', src: '/icons/gegner-konstrukt-00.png' },
  { id: 'gegner-konstrukt-01', kind: 'npc', category: 'Konstrukt', name: 'Zahnräder', src: '/icons/gegner-konstrukt-01.png' },
  { id: 'gegner-konstrukt-02', kind: 'npc', category: 'Konstrukt', name: 'Leere Rüstung', src: '/icons/gegner-konstrukt-02.png' },
  { id: 'gegner-konstrukt-03', kind: 'npc', category: 'Konstrukt', name: 'Kristall', src: '/icons/gegner-konstrukt-03.png' },
  { id: 'gegner-konstrukt-04', kind: 'npc', category: 'Konstrukt', name: 'Vogelscheuche', src: '/icons/gegner-konstrukt-04.png' },
  { id: 'gegner-mensch-00', kind: 'npc', category: 'Mensch', name: 'Magier', src: '/icons/gegner-mensch-00.png' },
  { id: 'gegner-mensch-01', kind: 'npc', category: 'Mensch', name: 'Kultist', src: '/icons/gegner-mensch-01.png' },
  { id: 'gegner-mensch-02', kind: 'npc', category: 'Mensch', name: 'Ritterhelm', src: '/icons/gegner-mensch-02.png' },
  { id: 'gegner-mensch-03', kind: 'npc', category: 'Mensch', name: 'Schurkenmaske', src: '/icons/gegner-mensch-03.png' },
  { id: 'gegner-mensch-04', kind: 'npc', category: 'Mensch', name: 'Hexer', src: '/icons/gegner-mensch-04.png' },
  { id: 'gegner-pflanze', kind: 'npc', category: 'Pflanze', name: 'Dornranke', src: '/icons/gegner-pflanze.png' },
  { id: 'gegner-gnom', kind: 'npc', category: 'Gnom', name: 'Gnomengesicht', src: '/icons/gegner-gnom.png' },
];

export const DEFAULT_ITEM_ICON = '/icons/waffen-00.png';
export const DEFAULT_SPELL_ICON = '/icons/element-00.png';
export const DEFAULT_CLASS_ICON = '/icons/klasse-krieger-00.png';
export const DEFAULT_NPC_ICON = '/icons/gegner-ork-00.png';

const ITEM_TYPE_FALLBACK: Record<string, string> = {
  waffe: '/icons/waffen-00.png',
  weapon: '/icons/waffen-00.png',
  zauberstab: '/icons/staebe-00.png',
  stab: '/icons/staebe-00.png',
  kriegshammer: '/icons/haemmer-00.png',
  hammer: '/icons/haemmer-00.png',
  ruestung: '/icons/ruestung-20.png',
  rüstung: '/icons/ruestung-20.png',
  armor: '/icons/ruestung-20.png',
  schild: '/icons/ruestung-00.png',
  helm: '/icons/ruestung-10.png',
  schuhe: '/icons/schuhe-00.png',
  handschuhe: '/icons/handschuhe-00.png',
  handschuh: '/icons/handschuhe-00.png',
  stiefel: '/icons/schuhe-00.png',
  boot: '/icons/schuhe-00.png',
  trank: '/icons/ausruestung-00.png',
  potion: '/icons/ausruestung-00.png',
  schmuck: '/icons/ausruestung-10.png',
  schluessel: '/icons/ausruestung-20.png',
  schlüssel: '/icons/ausruestung-20.png',
  schriftrolle: '/icons/schrift-00.png',
  werkzeug: '/icons/schrift-10.png',
  gold: '/icons/schrift-20.png',
  sonstiges: '/icons/schrift-21.png',
};

const ITEM_NAME_FALLBACK: Array<[string, string]> = [
  ['angriffswürfel', '/icons/sonstiges-wuerfel-angriff.png'],
  ['angriffswuerfel', '/icons/sonstiges-wuerfel-angriff.png'],
  ['rüstungswürfel', '/icons/sonstiges-wuerfel-ruestung.png'],
  ['ruestungswuerfel', '/icons/sonstiges-wuerfel-ruestung.png'],
  ['pferd', '/icons/sonstiges-pferd.png'],
  ['speer', '/icons/waffen-speer.png'],
  ['lagerfeuer', '/icons/werkzeug-lagerfeuer.png'],
  ['reparatur', '/icons/werkzeug-reparatur.png'],
  ['bogen', '/icons/waffen-10.png'],
  ['axt', '/icons/waffen-20.png'],
  ['schwert', '/icons/waffen-00.png'],
  ['hammer', '/icons/haemmer-00.png'],
  ['handschuh', '/icons/handschuhe-00.png'],
  ['helm', '/icons/ruestung-10.png'],
  ['schild', '/icons/ruestung-00.png'],
  ['rüstung', '/icons/ruestung-20.png'],
  ['ruestung', '/icons/ruestung-20.png'],
  ['heiltrank', '/icons/ausruestung-00.png'],
  ['manatrank', '/icons/ausruestung-01.png'],
  ['stärketrank', '/icons/ausruestung-04.png'],
  ['staerketrank', '/icons/ausruestung-04.png'],
  ['unsichtbar', '/icons/ausruestung-02.png'],
  ['hiljekarte', '/icons/schrift-01.png'],
  ['rückruf', '/icons/schrift-00.png'],
  ['rueckruf', '/icons/schrift-00.png'],
  ['gold', '/icons/schrift-20.png'],
  ['naturessenz', '/icons/sonstiges-naturessenz.png'],
  ['naturessen', '/icons/sonstiges-naturessenz.png'],
];

const CLASS_NAME_FALLBACK: Record<string, string> = {
  'orc-kämpferin': '/icons/klasse-orc-kaempferin.png',
  'orc-kaempferin': '/icons/klasse-orc-kaempferin.png',
  'mystischer schütze': '/icons/klasse-mystischer-schuetze.png',
  'mystischer schuetze': '/icons/klasse-mystischer-schuetze.png',
  walddrache: '/icons/klasse-walddrache.png',
  waldschrat: '/icons/klasse-waldschrat.png',
  gefährte: '/icons/klasse-gefaehrte.png',
  gefaehrte: '/icons/klasse-gefaehrte.png',
  magier: '/icons/klasse-magier-00.png',
  zauberer: '/icons/klasse-magier-00.png',
  elementar: '/icons/klasse-elementar.png',
  paladin: '/icons/klasse-paladin-00.png',
  priester: '/icons/klasse-priester-00.png',
  kleriker: '/icons/klasse-priester-00.png',
  heiler: '/icons/klasse-heiler.png',
  wald: '/icons/klasse-wald-00.png',
  jaeger: '/icons/klasse-wald-00.png',
  jäger: '/icons/klasse-wald-00.png',
  schütze: '/icons/klasse-wald-00.png',
  schuetze: '/icons/klasse-wald-00.png',
  bogensch: '/icons/klasse-wald-00.png',
  dieb: '/icons/klasse-dieb-00.png',
  schurke: '/icons/klasse-dieb-00.png',
  assassine: '/icons/klasse-assassine.png',
  krieger: '/icons/klasse-krieger-00.png',
  schwert: '/icons/klasse-krieger-00.png',
  front: '/icons/klasse-krieger-01.png',
  axt: '/icons/klasse-krieger-02.png',
  speer: '/icons/waffen-speer.png',
  druide: '/icons/klasse-druide.png',
  natur: '/icons/klasse-druide.png',
  fee: '/icons/klasse-fee.png',
  pixie: '/icons/klasse-fee.png',
  nekromant: '/icons/klasse-nekromant.png',
  mönch: '/icons/klasse-moench.png',
  moench: '/icons/klasse-moench.png',
  akrobat: '/icons/klasse-akrobat.png',
  oger: '/icons/klasse-oger.png',
  orc: '/icons/gegner-ork-00.png',
  ork: '/icons/gegner-ork-00.png',
  org: '/icons/gegner-ork-00.png',
  pilz: '/icons/klasse-pilz.png',
  bestie: '/icons/gegner-bestie-00.png',
  fusion: '/icons/klasse-elementar.png',
  drache: '/icons/gegner-drache-00.png',
};

export function isKitIcon(url?: string | null) {
  if (!url) return false;
  return url.split('?')[0].startsWith(KIT_ICON_PREFIX);
}

/** Kit-Icon-URL mit Cache-Bust (Query bleibt für isKitIcon unerheblich). */
export function withKitIconVersion(url: string) {
  const base = url.split('?')[0];
  return `${base}?v=${KIT_ICON_VERSION}`;
}

export function fallbackClassIcon(className?: string | null) {
  const key = (className || '').toLowerCase();
  for (const [marker, src] of Object.entries(CLASS_NAME_FALLBACK)) {
    if (key.includes(marker)) return src;
  }
  return DEFAULT_CLASS_ICON;
}

export function classIconSrc(className?: string | null, stored?: string | null) {
  if (isKitIcon(stored)) return stored as string;
  return fallbackClassIcon(className);
}

const NPC_TYPE_FALLBACK: Record<string, string> = {
  ork: '/icons/gegner-ork-00.png',
  orc: '/icons/gegner-ork-00.png',
  goblin: '/icons/gegner-goblin-00.png',
  gobkong: '/icons/gegner-goblin-00.png',
  drache: '/icons/gegner-drache-00.png',
  dragon: '/icons/gegner-drache-00.png',
  wyrm: '/icons/gegner-drache-00.png',
  untot: '/icons/gegner-untoter-00.png',
  zombie: '/icons/gegner-untoter-00.png',
  lich: '/icons/gegner-untoter-00.png',
  geist: '/icons/gegner-untoter-00.png',
  bandit: '/icons/gegner-bandit-00.png',
  räuber: '/icons/gegner-bandit-00.png',
  raeuber: '/icons/gegner-bandit-00.png',
  sumpf: '/icons/gegner-bandit-00.png',
  bestie: '/icons/gegner-bestie-00.png',
  wolf: '/icons/gegner-bestie-00.png',
  dämon: '/icons/gegner-daemon-00.png',
  daemon: '/icons/gegner-daemon-00.png',
  demon: '/icons/gegner-daemon-00.png',
  konstrukt: '/icons/gegner-konstrukt-00.png',
  golem: '/icons/gegner-konstrukt-00.png',
  mimic: '/icons/gegner-konstrukt-00.png',
  mensch: '/icons/gegner-mensch-00.png',
  human: '/icons/gegner-mensch-00.png',
  magier: '/icons/gegner-mensch-00.png',
  alde: '/icons/gegner-mensch-00.png',
  pflanze: '/icons/gegner-pflanze.png',
  ranke: '/icons/gegner-pflanze.png',
  rose: '/icons/gegner-pflanze.png',
  baum: '/icons/gegner-pflanze.png',
  gnom: '/icons/gegner-gnom.png',
  oger: '/icons/klasse-oger.png',
};

const SPELL_NAME_FALLBACK: Array<[string, string]> = [
  ['feuerball', '/icons/element-00.png'],
  ['meteor', '/icons/element-02.png'],
  ['eis', '/icons/element-10.png'],
  ['blitz', '/icons/element-20.png'],
  ['kettenblitz', '/icons/element-21.png'],
  ['heil', '/icons/arkan-10.png'],
  ['gruppenheil', '/icons/arkan-12.png'],
  ['wiederbelebung', '/icons/arkan-wiederbelebung.png'],
  ['magiewand', '/icons/arkan-wand.png'],
  ['schmiede', '/icons/arkan-schmiede.png'],
  ['würfel', '/icons/arkan-wuerfel.png'],
  ['wuerfel', '/icons/arkan-wuerfel.png'],
  ['stärke', '/icons/arkan-staerke.png'],
  ['staerke', '/icons/arkan-staerke.png'],
  ['flink', '/icons/arkan-flinke-fuesse.png'],
  ['magieball', '/icons/arkan-01.png'],
  ['magiepfeil', '/icons/element-23.png'],
  ['kampfzauber', '/icons/element-03.png'],
  ['mini buff', '/icons/schule-23.png'],
  ['minibuff', '/icons/schule-23.png'],
];

export function fallbackNpcIcon(npcType?: string | null) {
  const key = (npcType || '').toLowerCase();
  for (const [marker, src] of Object.entries(NPC_TYPE_FALLBACK)) {
    if (key.includes(marker)) return src;
  }
  return DEFAULT_NPC_ICON;
}

export function npcIconSrc(npcType?: string | null, stored?: string | null) {
  if (isKitIcon(stored)) return stored as string;
  return fallbackNpcIcon(npcType);
}

export function pictogramsOf(kind: PictogramKind) {
  return KIT_PICTOGRAMS.filter(icon => icon.kind === kind);
}

export function fallbackItemIcon(type?: string | null, name?: string | null) {
  const nameKey = (name || '').toLowerCase();
  for (const [marker, src] of ITEM_NAME_FALLBACK) {
    if (nameKey.includes(marker)) return src;
  }
  const key = (type || '').toLowerCase();
  for (const [marker, src] of Object.entries(ITEM_TYPE_FALLBACK)) {
    if (key.includes(marker)) return src;
  }
  return DEFAULT_ITEM_ICON;
}

export function fallbackSpellIcon(name?: string | null) {
  const key = (name || '').toLowerCase();
  for (const [marker, src] of SPELL_NAME_FALLBACK) {
    if (key.includes(marker)) return src;
  }
  return DEFAULT_SPELL_ICON;
}
